import React from 'react';

export const ActionButton = ({ icon, label, onClick, count }) => (
  <button
    onClick={onClick}
    style={{
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      padding: '10px 16px',
      backgroundColor: 'rgba(86, 141, 237, 0.15)',
      border: '1px solid rgba(86, 141, 237, 0.3)',
      borderRadius: 8,
      color: '#FFFFFF',
      fontFamily: 'Montserrat',
      fontSize: '14px',
      fontWeight: 500,
      cursor: 'pointer',
      transition: 'all 0.2s ease'
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.backgroundColor = 'rgba(86, 141, 237, 0.25)';
      e.currentTarget.style.borderColor = 'rgba(86, 141, 237, 0.5)';
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.backgroundColor = 'rgba(86, 141, 237, 0.15)';
      e.currentTarget.style.borderColor = 'rgba(86, 141, 237, 0.3)';
    }}
  >
    <i className={`fa-solid ${icon}`} style={{ fontSize: 14 }}></i>
    <span>{label}</span>
    {count > 0 && (
      <span style={{
        position: 'absolute',
        top: -6,
        right: -6,
        width: 20,
        height: 20,
        borderRadius: '50%',
        backgroundColor: '#EB4040',
        color: '#FFFFFF',
        fontSize: 11,
        fontWeight: 600,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>{count}</span>
    )}
  </button>
);

const QuickActions = ({ employeeId, pendingPTOCount, handleQuickAction }) => (
  <div style={{
    display: 'flex',
    gap: 12,
    flexWrap: 'wrap',
    marginTop: 24,
    paddingTop: 24,
    borderTop: '1px solid rgba(86, 141, 237, 0.2)'
  }}>
    <ActionButton icon="fa-envelope" label="Send Email" onClick={() => handleQuickAction('email')} />
    <ActionButton icon="fa-calendar-plus" label="Schedule Review" onClick={() => handleQuickAction('schedule-review')} />
    <ActionButton icon="fa-check-circle" label="Approve PTO" onClick={() => handleQuickAction('approve-pto')} count={pendingPTOCount} />
    <ActionButton icon="fa-money-bill-wave" label="Req. Salary Change" onClick={() => handleQuickAction('req-salary')} />
    <ActionButton icon="fa-sack-dollar" label="Req. Bonus" onClick={() => handleQuickAction('req-bonus')} />
    <ActionButton icon="fa-user-slash" label="Init. Offboarding" onClick={() => handleQuickAction('req-offboarding')} />
    <ActionButton icon="fa-circle-question" label="Req. Info" onClick={() => handleQuickAction('req-info')} />
    <ActionButton icon="fa-upload" label="Upload Document" onClick={() => handleQuickAction('upload-doc')} />
    <ActionButton icon="fa-comment" label="Add Note" onClick={() => handleQuickAction('add-note')} />
  </div>
);

export default QuickActions;

